import {
  ADD_GROUP,
  EDIT_GROUP,
  GET_GROUP_LIST,
  DELETE_GROUP,
  ADD_USER,
  EDIT_USER,
  DELETE_USER,
  GET_USER_LIST,
  GET_DELETED_DATA,
  LIST_BOX_FILES,
  UPLOAD_BOX_FILES,
  GET_OUT_PUT_LIST,
  GET_OUT_PUT_URL,
  BATCH_TYPE,
  UPLOAD_DATA,
  PRODUCT_TYPE,
  MANAGE_GROUP,
  GET_BATCH_DATA,
  REJECT_OUT_PUT_FILE_BATCH,
  GET_AUDIT_LIST,
  CLEAR_API_STATUS,
  GET_AUDIT_DETAILS,
  LIST_BATCH_RECORD,
  SUBMIT_OUT_PUT_FILE_UPLOAD,
  GET_USER_ACTIVITY,
  GET_USER_NAME,
  GET_DATA_POINT_CALCULATION,
  GET_DP_DETAILS,
  GET_MERGE_BATCHES,
  GET_MERGE_PROJECTS,
  API_STATUS_MASTER,
  GET_MERGED_FILES,
  CLEAR_GET_MERGED_FILES,
  GET_AUDIT_HISTORY,
  GET_VISUALIZATION_DATA,
  VISUALIZATION_SUBMIT_STATUS,
  GET_REJECTED_BATCHES_FOR_COL_INSERTION,
  BATCHES_APPROVED_STATUS,
  GET_NOTIFICATIONS,
  GET_EXTRACTED_DATA,
  VISUALIZATION_DATA_HISTORY,
  VISUALIZATION_SUBMIT_QUERY,
  GET_VISUALIZATION_PROJECTS,
  VISUALIZATION_SUBMIT_RESULT,
  GET_VISUALIZATION_DETAILS,
  GET_DATA_TO_FILTER,
  GET_DATA_TO_FILTER_SEARCH,
  GET_VISUALIZATION_TABLE_DATA,
  GET_VISUALIZATION_BOX_DATA,
  // GET_FILTERED_DATA,
  // GET_ALL_PROJECT_NAMES,
  // GET_ALL_BATCH_NAMES,
  // GET_ALL_MBR_NAMES,
  // GET_ALL_GROUP_USER_NAMES,
  // GET_ALL_PARAMETER_NAMES,
  // GET_LOG_PDF_URL,
  GET_HISTORY_DATA,
  GET_HISTORY_PREVIEW_DATA,
  HANDLE_DELETE,
  HANDLE_REFRESH_BOX_FOLDERS,
  HANDLE_DELETE_BATCH_LOGS,
  HANDLE_DELETE_PROJECT_LOGS,
  //GET_STATUS,
} from "./types";
import { initialState } from "./initialState";
import { errorMessage } from "../../constants/responseMessages";
import AdministratorService from "../../services/administratorService";
import UploadBatchAPI from "../../services/uploadBatchService";

const service = new AdministratorService();
const uploadBatchAPI = new UploadBatchAPI();

export const getManageGroupsList = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getManageGroupList()
      .then((res) => {
        dispatch({
          type: GET_GROUP_LIST,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getAuditTrailList = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getAuditTrailList(data)
      .then((res) => {
        dispatch({
          type: GET_AUDIT_LIST,
          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: { ...initialState?.apiStatus, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getAuditDetails = (project_id, batch_id) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service.getAuditDetails(project_id, batch_id).then((res) => {
      dispatch({
        type: GET_AUDIT_DETAILS,
        payload: res.data,
      }).catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
    });
  };
};
export const getUserActivity = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: {
        ...initialState.apiStatus,
        message: "",
        loader: true,
        next: false,
      },
    });
    service
      .getUserActivity(data)
      .then((res) => {
        dispatch({
          type: GET_USER_ACTIVITY,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_USER_ACTIVITY,
          payload: [
            {
              message: errorMessage(error),
              loader: false,
              next: false,
            },
          ],
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getManageGroup = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { message: "", loader: true, next: false },
    });
    service
      .getManageGroup()
      .then((res) => {
        dispatch({
          type: MANAGE_GROUP,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: MANAGE_GROUP,
          payload: [
            {
              message: errorMessage(error),
              loader: false,
              next: false,
            },
          ],
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getUsersByGroup = (groupName) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { message: "", loader: true, next: false },
    });
    service
      .getUsersByGroup(groupName)
      .then((res) => {
        dispatch({
          type: GET_USER_NAME,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const addNewGroup = (name) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { message: "", loader: true, next: false },
    });
    service
      .addNewGroup({ name: name })
      .then((json) => {
        dispatch({
          type: ADD_GROUP,
          payload: { message: "group added", loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: ADD_GROUP,
          payload: {
            message: errorMessage(error),
            loader: false,
            next: false,
          },
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const deleteGroup = (userId) => {
  return (dispatch) => {
    dispatch({
      type: DELETE_GROUP,
      payload: [],
    });
    service
      .deleteGroup(userId)
      .then((json) => {
        dispatch({
          type: DELETE_GROUP,
          payload: { message: "group deleted", loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: DELETE_GROUP,
          payload: {
            message: errorMessage(error),
            loader: false,
            next: false,
          },
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const editGroup = (name, id) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { message: "", loader: true, next: false },
    });
    service
      .updateGroup({ name: name }, id)
      .then((json) => {
        dispatch({
          type: EDIT_GROUP,
          payload: { message: "group edited", loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: EDIT_GROUP,
          payload: {
            message: errorMessage(error),
            loader: false,
            next: false,
          },
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getUserList = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getUserList(data)
      .then((res) => {
        dispatch({
          type: GET_USER_LIST,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_USER_LIST,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
          },
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const addNewUser = (name) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { message: "", loader: true, next: false },
    });
    service
      .addNewUser(name)
      .then((json) => {
        dispatch({
          type: ADD_USER,
          payload: { message: "user added", loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: ADD_USER,
          payload: {
            message: errorMessage(error),
            loader: false,
            next: false,
          },
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const deleteUser = (userId) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: [],
    });
    service
      .deleteUser(userId)
      .then((json) => {
        dispatch({
          type: DELETE_USER,
          payload: { message: "user deleted", loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: DELETE_USER,
          payload: {
            message: errorMessage(error),
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const editUser = (name, id) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { message: "", loader: true, next: false },
    });
    service
      .editUser(name, id)
      .then((json) => {
        dispatch({
          type: EDIT_USER,
          payload: { message: "user edited", loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: EDIT_USER,
          payload: {
            message: errorMessage(error),
            loader: false,
            next: false,
          },
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

// ----------------data deletion

export const getDeletedData = (obj) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: GET_DELETED_DATA,
      payload: {},
    });
    service
      .getDeletedData(obj)
      .then((res) => {
        dispatch({
          type: GET_DELETED_DATA,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_DELETED_DATA,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
          },
        });
      });
  };
};

// ------------ upload batch

export const listBoxFiles = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: LIST_BOX_FILES,
      payload: [],
    });
    uploadBatchAPI
      .listBoxFiles(data)
      .then((res) => {
        dispatch({
          type: LIST_BOX_FILES,
          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: LIST_BOX_FILES,
          payload: [
            {
              ...initialState?.apiStatus,
              message: errorMessage(error),
              loader: false,
              next: false,
            },
          ],
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const uploadBoxFiles = (fileType, requestBody) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    uploadBatchAPI
      .uploadBoxFiles(fileType, requestBody)
      .then((res) => {
        dispatch({
          type: UPLOAD_BOX_FILES,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: UPLOAD_BOX_FILES,
          payload: [
            {
              ...initialState?.apiStatus,
              message: errorMessage(error),
              loader: false,
              next: false,
            },
          ],
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const ApiStatus = (CLEAR_API_STATUS) => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_API_STATUS,
      payload: {},
    });
  };
};

export const ClearOutPutListApiStatus = (CLEAR_API_STATUS) => {
  return (dispatch) => {
    dispatch({
      type: GET_OUT_PUT_LIST,
      payload: {},
    });
  };
};

export const getOutPutList = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_OUT_PUT_LIST,
      payload: {
        message: null,
        next: false,
        apiError: false,
        apiSuccess: false,
        loader: true,
      },
    });
    service
      .getManageOutput(data)
      .then((res) => {
        dispatch({
          type: GET_OUT_PUT_LIST,
          payload: {
            message: null,
            next: false,
            data: res.data,
            apiError: false,
            apiSuccess: false,
            loader: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_OUT_PUT_LIST,
          payload: {
            data: [],
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
export const getOutPutUrl = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getManageOutputUrl(data)
      .then((res) => {
        dispatch({
          type: GET_OUT_PUT_URL,
          payload: res.data.data,
          loader: false,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: { ...initialState?.apiStatus, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const clearRejectoutputFileBatch = () => {
  return (dispatch) => {
    dispatch({
      type: REJECT_OUT_PUT_FILE_BATCH,
      payload: { ...initialState?.apiStatus },
    });
  };
};

export const rejectoutputFileBatch = (data) => {
  return (dispatch) => {
    dispatch({
      type: REJECT_OUT_PUT_FILE_BATCH,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .rejectoutputFileBatch(data)
      .then((res) => {
        dispatch({
          type: REJECT_OUT_PUT_FILE_BATCH,
          payload: {
            ...initialState?.apiStatus,
            data: res.data.data,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: REJECT_OUT_PUT_FILE_BATCH,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
            apiSuccess: false,
          },
        });
      });
  };
};

export const clearSubmitOutputUpload = () => {
  return (dispatch) => {
    dispatch({
      type: SUBMIT_OUT_PUT_FILE_UPLOAD,
      payload: { ...initialState?.apiStatus },
    });
  };
};

export const submitOutputUpload = (data) => {
  return (dispatch) => {
    dispatch({
      type: SUBMIT_OUT_PUT_FILE_UPLOAD,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .submitOutputUpload(data)
      .then((res) => {
        dispatch({
          type: SUBMIT_OUT_PUT_FILE_UPLOAD,
          payload: {
            ...initialState?.apiStatus,
            data: res.data.data,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: SUBMIT_OUT_PUT_FILE_UPLOAD,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
            apiSuccess: false,
          },
        });
      });
  };
};

export const getBatchRecordType = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState.apiStatus, loader: true },
    });

    service
      .getBatchRecordType()
      .then((res) => {
        dispatch({
          type: BATCH_TYPE,
          payload: res.data,
        });

        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            // message: res?.data?.message,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
export const uploadClientData = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { message: "", loader: true, next: false },
    });
    dispatch({
      type: UPLOAD_DATA,
      payload: { message: "", loader: false, apiSuccess: false },
    });
    service
      .uploadClientData(data)
      .then((res) => {
        dispatch({
          type: UPLOAD_DATA,
          payload: {
            message: res?.data?.message,
            loader: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: { message: "", loader: false, next: true },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
export const getDrugTypeList = () => {
  return (dispatch) => {
    // dispatch({
    //   type: API_STATUS_MASTER,
    //   payload: { message: "", loader: true, next: false },
    // });
    service
      .getDrugTypeList()
      .then((res) => {
        dispatch({
          type: PRODUCT_TYPE,
          payload: res.data.data,
        });
        // dispatch({
        //   type: API_STATUS_MASTER,
        //   payload: {
        //     ...initialState.apiStatus,
        //     // message: res?.data?.message,
        //     loader: false,
        //     next: false,
        //   },
        // });
      })
      .catch((error) => {
        //   dispatch({
        //     type: API_STATUS_MASTER,
        //     payload: {
        //       ...initialState.apiStatus,
        //       message: errorMessage(error),
        //       loader: false,
        //       next: false,
        //       apiError: true,
        //     },
        //   });
      });
  };
};
// export const getProductTypeSubFolder = (data) => {
//   return (dispatch) => {
//     dispatch({
//       type: PRODUCT_SUB_FOLDER,
//       payload: { message: "", loader: true, next: false },
//     });
//     service
//       .getProductTypeSubFolder(data)
//       .then((res) => {
//         dispatch({
//           type: PRODUCT_SUB_FOLDER,
//           payload: { message: "", loader: false, data: res.data.data },
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: API_STATUS_MASTER,
//           payload: {
//             ...initialState.apiStatus,
//             message: errorMessage(error),
//             loader: false,
//             next: false,
//             apiError: true,
//             data: [],
//           },
//         });

//         dispatch({
//           type: PRODUCT_SUB_FOLDER,
//           payload: { message: "", loader: false },
//         });
//       });
//   };
// };

export const getBatchDetailsList = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: GET_BATCH_DATA,
      // payload: res.data,
      payload: {
        projects: [],
        batches: [],
        total_count: 0,
      },
    });
    service
      .getBatchDetailsList(data)
      .then((res) => {
        dispatch({
          type: GET_BATCH_DATA,
          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
export const getBatchRecordList = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getBatchRecordList(data)
      .then((res) => {
        dispatch({
          type: LIST_BATCH_RECORD,
          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: { ...initialState?.apiStatus, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getDataCalculation = (id) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState, loader: true },
    });
    service
      .getDataCalculation(id)
      .then((res) => {
        dispatch({
          type: GET_DATA_POINT_CALCULATION,
          payload: res.data.data,
          loader: false,
          next: false,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: { ...initialState?.apiStatus, loader: false, next: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState,
            msg: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const calculateDataPoints = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .calculateDataPoints(data)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const clearApiStatus = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_API_STATUS,
      payload: {},
    });
  };
};

export const getDpCalculation = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getDpCalculation(data)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
export const getDpDetails = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getDpDetails(data)
      .then((res) => {
        dispatch({
          type: GET_DP_DETAILS,
          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: { ...initialState?.apiStatus, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getMergeProjectList = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getMergeProjectList()
      .then((res) => {
        dispatch({
          type: GET_MERGE_PROJECTS,
          payload: res.data.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const submitFinalOpFilesData = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .submitFinalOpFilesData(data)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            apiSuccess: true,
            data: res.data,
            message: res.data.message,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const clearMergeBatches = () => {
  return (dispatch) => {
    dispatch({
      type: GET_MERGE_BATCHES,
      payload: [],
    });
  };
};

export const getMergeProjectBatches = (id) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getMergeProjectBatches(id)
      .then((res) => {
        dispatch({
          type: GET_MERGE_BATCHES,
          payload: res.data.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const mergePdfFiles = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState.apiStatus, loader: true },
    });
    service
      .mergePdfFiles(data)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            msg: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getMergedFiles = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getMergedFiles()
      .then((res) => {
        dispatch({
          type: GET_MERGED_FILES,
          payload: res.data.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const clearGetMergedFiles = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_GET_MERGED_FILES,
      payload: [],
    });
  };
};

export const createTemplates = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .createTemplates(data)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
export const getAuditHistory = (projectId, batchId) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });

    service
      .getAuditHistoryDetail(projectId, batchId)
      .then((res) => {
        dispatch({
          type: GET_AUDIT_HISTORY,
          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getFilesDataForVisualization = (data) => {
  return (dispatch) => {
    // dispatch({
    //   type: API_STATUS_MASTER,
    //   payload: { ...initialState?.apiStatus, loader: true },
    // });
    dispatch({
      type: GET_VISUALIZATION_DATA,
      payload: {
        loader: true,
        message: null,
        next: false,
        data: [],
        apiError: false,
        apiSuccess: false,
      },
    });
    service
      .getFilesDataForVisualization(data)
      .then((res) => {
        dispatch({
          type: GET_VISUALIZATION_DATA,
          payload: {
            ...res?.data,
            loader: false,
            message: null,
            next: false,
            apiError: false,
            apiSuccess: false,
          },
        });
        // dispatch({
        //   type: API_STATUS_MASTER,
        //   payload: {
        //     ...initialState.apiStatus,
        //     message: res?.data?.message,
        //     loader: false,
        //     next: false,
        //   },
        // });
      })
      .catch((error) => {
        dispatch({
          type: GET_VISUALIZATION_DATA,
          payload: {
            data: [],
            apiSuccess: false,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
        // dispatch({
        //   type: API_STATUS_MASTER,
        //   payload: {
        //     ...initialState?.apiStatus,
        //     message: errorMessage(error),
        //     loader: false,
        //     next: false,
        //     apiError: true,
        //   },
        // });
      });
  };
};

export const submitForVisualization = (data) => {
  return (dispatch) => {
    dispatch({
      type: VISUALIZATION_SUBMIT_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: API_STATUS_MASTER,
      payload: {
        ...initialState.apiStatus,
        loader: true,
      },
    });
    service
      .submitForVisualization(data)
      .then((res) => {
        dispatch({
          type: VISUALIZATION_SUBMIT_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: VISUALIZATION_SUBMIT_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const clearVisualizationSubmitStatus = () => {
  return (dispatch) => {
    dispatch({
      type: VISUALIZATION_SUBMIT_STATUS,
      payload: {
        ...initialState.apiStatus,
      },
    });
  };
};

// SUBMIT FOR VISUALIZATION QUERY
export const submitForVisualizationQuery = (data) => {
  return (dispatch) => {
    dispatch({
      type: VISUALIZATION_SUBMIT_QUERY,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .submitForVisualizationQuery(data)
      .then((res) => {
        dispatch({
          type: VISUALIZATION_SUBMIT_QUERY,
          payload: {
            ...initialState?.apiStatus,
            data: res?.data,
            message: res?.data?.message,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: VISUALIZATION_SUBMIT_QUERY,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

//GET HISTORY DATA FOR VISUALIZATION
export const getHistoryDataForVisualization = () => {
  return (dispatch) => {
    dispatch({
      type: VISUALIZATION_DATA_HISTORY,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: VISUALIZATION_DATA_HISTORY,
      payload: [],
    });
    service
      .getHistoryDataForVisualization()
      .then((res) => {
        dispatch({
          type: VISUALIZATION_DATA_HISTORY,
          payload: res?.data?.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: VISUALIZATION_DATA_HISTORY,
          payload: [],
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

// GET VISUALIZATION PROJECTS
export const getVisualizationDetails = (id) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: GET_VISUALIZATION_DETAILS,
      payload: [],
    });
    service
      .getVisualizationDetails(id)
      .then((res) => {
        dispatch({
          type: GET_VISUALIZATION_DETAILS,
          payload: res?.data?.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_VISUALIZATION_DETAILS,
          payload: { error: true, message: errorMessage(error) },
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

// GET VISUALIZATION PROJECTS
export const getVisualizationProjects = () => {
  return (dispatch) => {
    dispatch({
      type: GET_VISUALIZATION_PROJECTS,
      payload: [],
    });
    service
      .getVisualizationProjects()
      .then((res) => {
        dispatch({
          type: GET_VISUALIZATION_PROJECTS,
          payload: res?.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_VISUALIZATION_PROJECTS,
          payload: [],
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
//SUBMIT/SAVE FOR VISUALIZATION RESULT
export const submitForVisualizationResult = (data) => {
  return (dispatch) => {
    dispatch({
      type: VISUALIZATION_SUBMIT_RESULT,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .submitForVisualizationResult(data)
      .then((res) => {
        dispatch({
          type: VISUALIZATION_SUBMIT_RESULT,
          payload: {
            ...initialState?.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: VISUALIZATION_SUBMIT_RESULT,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getBatchRejectedDataForColInsertion = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: GET_REJECTED_BATCHES_FOR_COL_INSERTION,
      payload: [],
    });
    service
      .getBatchRejectedDataForColInsertion(data)
      .then((res) => {
        dispatch({
          type: GET_REJECTED_BATCHES_FOR_COL_INSERTION,
          payload: res?.data?.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_REJECTED_BATCHES_FOR_COL_INSERTION,
          payload: [],
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const submitBatchApprovelForColInsertion = (data) => {
  return (dispatch) => {
    dispatch({
      type: BATCHES_APPROVED_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .submitBatchApprovelForColInsertion(data)
      .then((res) => {
        dispatch({
          type: BATCHES_APPROVED_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: BATCHES_APPROVED_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const clearApprovedBatchesSatus = () => {
  return (dispatch) => {
    dispatch({
      type: BATCHES_APPROVED_STATUS,
      payload: {
        ...initialState.apiStatus,
      },
    });
  };
};

export const getNotifications = () => {
  return (dispatch) => {
    service
      .getNotifications()
      .then((res) => {
        dispatch({
          type: GET_NOTIFICATIONS,
          payload: res.data.data,
        });
      })
      .catch((error) => {});
  };
};

export const getExtractedData = (projectId, batchId) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });

    service
      .getExtractedData(projectId, batchId)
      .then((res) => {
        dispatch({
          type: GET_EXTRACTED_DATA,
          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const clearAuditTrailHistory = (projectId, batchId) => {
  return (dispatch) => {
    dispatch({
      type: GET_EXTRACTED_DATA,
      payload: [],
    });
    dispatch({
      type: GET_AUDIT_HISTORY,
      payload: [],
    });
  };
};
export const getDataToFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });

    service
      .getDataToFilter(data)
      .then((res) => {
        dispatch({
          type: GET_DATA_TO_FILTER,
          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const extractionDetailFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });

    service
      .getExtractionDataToFilter(data)
      .then((res) => {
        dispatch({
          type: GET_DATA_TO_FILTER_SEARCH,
          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

// export const getAllProjectNames = () => {
//   return (dispatch) => {
//     dispatch({
//       type: GET_ALL_PROJECT_NAMES,
//       payload: [],
//     });
//     // clear batch names not added here as on change project when action dispatch that time its setting to empty value
//     dispatch({
//       type: GET_ALL_MBR_NAMES,
//       payload: [],
//     });
//     dispatch({
//       type: GET_ALL_PARAMETER_NAMES,
//       payload: [],
//     });

//     service
//       .getAllProjectNames()
//       .then((res) => {
//         dispatch({
//           type: GET_ALL_PROJECT_NAMES,
//           payload: res?.data?.data,
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: GET_ALL_PROJECT_NAMES,
//           payload: [],
//         });
//       });
//   };
// };

// export const getAllBatchNames = (projectId) => {
//   return (dispatch) => {
//     dispatch({
//       type: GET_ALL_BATCH_NAMES,
//       payload: [],
//     });

//     service
//       .getAllBatchNames(projectId)
//       .then((res) => {
//         dispatch({
//           type: GET_ALL_BATCH_NAMES,
//           payload: res?.data?.data,
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: GET_ALL_BATCH_NAMES,
//           payload: [],
//         });
//       });
//   };
// };
// export const getAllMBRNames = (projectId, batchId) => {
//   return (dispatch) => {
//     dispatch({
//       type: GET_ALL_MBR_NAMES,
//       payload: [],
//     });
//     service
//       .getAllMBRNames(projectId, batchId)
//       .then((res) => {
//         dispatch({
//           type: GET_ALL_MBR_NAMES,
//           payload: res?.data?.data,
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: GET_ALL_MBR_NAMES,
//           payload: [],
//         });
//       });
//   };
// };
// export const getAllUserGroupAndNames = () => {
//   return (dispatch) => {
//     dispatch({
//       type: GET_ALL_GROUP_USER_NAMES,
//       payload: [],
//     });
//     service
//       .getAllUserGroupAndNames()
//       .then((res) => {
//         dispatch({
//           type: GET_ALL_GROUP_USER_NAMES,
//           payload: res?.data?.data,
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: GET_ALL_GROUP_USER_NAMES,
//           payload: [],
//         });
//       });
//   };
// };
// export const getAllParameters = (projectId) => {
//   return (dispatch) => {
//     dispatch({
//       type: GET_ALL_PARAMETER_NAMES,
//       payload: [],
//     });

//     service
//       .getAllParameters(projectId)
//       .then((res) => {
//         dispatch({
//           type: GET_ALL_PARAMETER_NAMES,
//           payload: res?.data?.data,
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: GET_ALL_PARAMETER_NAMES,
//           payload: [],
//         });
//       });
//   };
// };

// export const getFilteredData = (data) => {
//   return (dispatch) => {
//     dispatch({
//       type: API_STATUS_MASTER,
//       payload: { ...initialState?.apiStatus, loader: true },
//     });

//     dispatch({
//       type: GET_FILTERED_DATA,
//       payload: [],
//     });

//     service
//       .getFilteredData(data)
//       .then((res) => {
//         dispatch({
//           type: GET_FILTERED_DATA,
//           payload: res?.data,
//         });
//         dispatch({
//           type: API_STATUS_MASTER,
//           payload: {
//             ...initialState.apiStatus,
//             message: res?.data?.message,
//             loader: false,
//             next: true,
//           },
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: API_STATUS_MASTER,
//           payload: {
//             ...initialState?.apiStatus,
//             message: errorMessage(error),
//             loader: false,
//             next: false,
//             apiError: true,
//           },
//         });
//         dispatch({
//           type: GET_FILTERED_DATA,
//           payload: [],
//         });
//       });
//   };
// };

export const addNewVisualizationTableName = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });

    service
      .addNewVisualizationTableName(data)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getVisualizationTableName = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });

    service
      .getVisualizationTableName(data)
      .then((res) => {
        dispatch({
          type: GET_VISUALIZATION_TABLE_DATA,
          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getVisualizationBoxData = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });

    service
      .getVisualizationBoxData()
      .then((res) => {
        dispatch({
          type: GET_VISUALIZATION_BOX_DATA,

          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

// export const getDataForExport = (projectId, batchId, data) => {
//   return (dispatch) => {
//     service
//       .getDataForExport(data)
//       .then((datares) => {
//         if (datares?.data?.data) {
//           dispatch({
//             type: GET_LOG_PDF_URL,
//             payload: { url: "", loader: true, apiError: false, message: "" },
//           });

//           service
//             .getPdfLink(datares?.data?.data)
//             .then((res) => {
//               dispatch({
//                 type: GET_LOG_PDF_URL,
//                 payload: {
//                   url: res?.data,
//                   loader: false,
//                   apiError: false,
//                   message: "",
//                 },
//               });

//               console.log("success");
//             })
//             .catch((error) => {
//               dispatch({
//                 type: GET_LOG_PDF_URL,
//                 payload: {
//                   url: "",
//                   loader: false,
//                   apiError: true,
//                   message: error?.message,
//                 },
//               });
//               console.log("error");
//             });
//         }
//       })

//       .catch((error) => {
//         console.log(error);
//       });
//   };
// };

// export const clearUrlData = () => {
//   return (dispatch) => {
//     dispatch({
//       type: GET_LOG_PDF_URL,
//       payload: { url: "", loader: false, apiError: false, message: "" },
//     });
//   };
// };

export const restoreHistoryData = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });

    service
      .restoreHistoryData(data)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const listHistoryData = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: GET_HISTORY_DATA,
      payload: [],
    });

    service
      .listHistoryData(data)
      .then((res) => {
        dispatch({
          type: GET_HISTORY_DATA,
          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const clearGetPreviewHistoryData = () => {
  return (dispatch) => {
    dispatch({
      type: GET_HISTORY_PREVIEW_DATA,
      payload: [],
    });
  };
};

export const getPreviewHistoryData = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });

    service
      .getPreviewHistoryData(data)
      .then((res) => {
        dispatch({
          type: GET_HISTORY_PREVIEW_DATA,
          payload: res.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: false,
            // apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

// export const userStatus = (data) => {
//   return (dispatch) => {
//     dispatch({
//       type: API_STATUS_MASTER,
//       payload: { ...initialState?.apiStatus, loader: true, notification: false },
//     });

//     service
//       .userStatus(data)
//       .then((res) => {
//         dispatch({
//           type: API_STATUS_MASTER,
//           payload: {
//             ...initialState.apiStatus,
//             message: res?.data?.message,
//             loader: false,
//             next: true,
//             apiSuccess: true,
//             notification: true
//           },
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: API_STATUS_MASTER,
//           payload: {
//             ...initialState?.apiStatus,
//             message: errorMessage(error),
//             loader: false,
//             next: false,
//             apiError: true,
//             notification: true
//           },
//         });
//       });
//   };
// };

export const getWsStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getWsStatus(data)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
          },
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const handleDeletePdf = (id) => {
  return (dispatch) => {
    dispatch({
      type: HANDLE_DELETE,
      payload: {
        loader: true,
        apiSuccess: false,
        notification: false,
      },
    });
    service
      .handleDeletePdf(id)
      .then((res) => {
        dispatch({
          type: HANDLE_DELETE,
          payload: {
            message: res?.data?.message,
            loader: false,
            apiSuccess: true,
            notification: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: HANDLE_DELETE,
          payload: {
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
            notification: false,
            apiSuccess: false,
          },
        });
      });
  };
};
export const handleClearPDFDeleteData = () => {
  return (dispatch) => {
    dispatch({
      type: HANDLE_DELETE,
      // payload: {},
      payload: {
        loader: false,
        apiSuccess: false,
        notification: false,
      },
    });
  };
};

export const clearPDFUploadData = () => {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_DATA,
      // payload: {},
      payload: {
        loader: false,
        apiSuccess: false,
        notification: false,
      },
    });
  };
};

export const userStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: {
        ...initialState?.apiStatus,
        loader: true,
        notification: false,
      },
    });

    service
      .userStatus(data)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
            apiSuccess: true,
            notification: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
            notification: true,
          },
        });
      });
  };
};

export const clearRefreshBoxFoldersStatus = () => {
  return (dispatch) => {
    dispatch({
      type: HANDLE_REFRESH_BOX_FOLDERS,
      payload: {
        loader: false,
        apiSuccess: false,
        notification: false,
        apiError: false,
      },
    });
  };
};

export const refreshBoxFolders = () => {
  return (dispatch) => {
    dispatch({
      type: HANDLE_REFRESH_BOX_FOLDERS,
      payload: {
        loader: true,
        apiSuccess: false,
        notification: false,
      },
    });
    service
      .refreshBoxFolders()
      .then((res) => {
        dispatch({
          type: HANDLE_REFRESH_BOX_FOLDERS,
          payload: {
            message: res?.data?.message,
            loader: false,
            apiSuccess: true,
            notification: true,
            next: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: HANDLE_REFRESH_BOX_FOLDERS,
          payload: {
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
            notification: false,
            apiSuccess: false,
          },
        });
      });
  };
};

export const handleClearDeleteBatchLogs = () => {
  return (dispatch) => {
    dispatch({
      type: HANDLE_DELETE_BATCH_LOGS,
      payload: {
        loader: false,
        apiSuccess: false,
        notification: false,
      },
    });
  };
};

export const deleteBatchLogs = (id) => {
  return (dispatch) => {
    dispatch({
      type: HANDLE_DELETE_BATCH_LOGS,
      payload: {
        loader: true,
        apiSuccess: false,
        notification: false,
      },
    });
    service
      .deleteBatchLogs(id)
      .then((res) => {
        dispatch({
          type: HANDLE_DELETE_BATCH_LOGS,
          payload: {
            message: res?.data?.message,
            loader: false,
            apiSuccess: true,
            notification: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: HANDLE_DELETE_BATCH_LOGS,
          payload: {
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
            notification: false,
            apiSuccess: false,
          },
        });
      });
  };
};

export const handleClearDeleteProjectLogs = () => {
  return (dispatch) => {
    dispatch({
      type: HANDLE_DELETE_PROJECT_LOGS,
      payload: {
        loader: false,
        apiSuccess: false,
        notification: false,
      },
    });
  };
};

export const deleteProjectLogs = (id) => {
  return (dispatch) => {
    dispatch({
      type: HANDLE_DELETE_PROJECT_LOGS,
      payload: {
        loader: true,
        apiSuccess: false,
        notification: false,
      },
    });
    service
      .deleteProjectLogs(id)
      .then((res) => {
        dispatch({
          type: HANDLE_DELETE_PROJECT_LOGS,
          payload: {
            message: res?.data?.message,
            loader: false,
            apiSuccess: true,
            notification: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: HANDLE_DELETE_BATCH_LOGS,
          payload: {
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
            notification: false,
            apiSuccess: false,
          },
        });
      });
  };
};


export const submitFilesForSRM = (ids) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });

    return service
      .submitFilesForSRM(ids)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            apiSuccess: true,
            data: res.data,
            message: res.data.message,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
        throw error;
      });
  };
};